import { NgModule } from '@angular/core';
import { Router } from '@angular/router';

import { SharedModule } from "../../shared/shared.module";

import { ActivityComponent } from './components/activity.component';
import { ActivityMainComponent } from './components/activity-main.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ActivityComponent, 
    ActivityMainComponent
    ]
})
export class ActivityModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/activity/activity.module.ts